import { NgModule } from '@angular/core';
import { LOGIN_ROUTES } from './login-routes';
import { LoginService } from './login.service';
import { LoginV2CommonService } from '@app/+login/deprecated-hybrid/login-v2-common.service';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    RouterModule.forChild(LOGIN_ROUTES),
    AccordionModule.forRoot(),
  ],
  providers: [LoginService, LoginV2CommonService],
})
export class LoginModule {}
